import { Wrapper } from 'AppReact';
import styled from 'styled-components';

const template = styled.div.attrs(
  ({ displayState }) => ({
    style: {
      transform: `translateX(${displayState?.swipe ?? 0}px)`
    }
  })
)`
    border: 1px solid #E3E3E3;
    box-shadow: 0px 1px 2px #00000014;
    border-radius: 12px;
    height: 100%;
    display: flex;
    align-items: center;
    position: absolute;
    width: 100%;
    top: 0;
    background: #F4FCF8;
    justify-content: space-around;
    padding-left: 40px;
`;

export default Wrapper(template);